import Inputmask from 'inputmask';

export const getPostalCode = (place) => {
    let postalCode = null;
    switch (place.place_id) {
        case 'EjE3MCBUb3duIENlbnRyZSBDb3VydCwgU2NhcmJvcm91Z2gsIE9OIE0xUCwgQ2FuYWRh':
            //70 Town Centre
            postalCode = 'M1P 0B2';
            break;
        case 'ChIJD9HcT9U0K4gRRQfCTDh8JAs':
            //8 York Street
            postalCode = 'M5J 2Y2';
            break;
        case 'ChIJy9mxbgw2K4gRlrE9UEI_5uw':
            //58 Marine Parade (Bus Stop Clone)
            postalCode = 'M8V 4G1';
            break;
        case 'ChIJeZ_4aAw2K4gRWY-VwbF-W-8':
            //58 Marine Parade
            postalCode = 'M8V 4G1';
            break;
        case 'c542ad9808bdd079a4129c5b9eb132d84ba19826':
            //80 Marine Parade
            postalCode = 'M8V 0A3';
            break;
        case 'EjEzIE1pY2hhZWwgUG93ZXIgUGwsIEV0b2JpY29rZSwgT04gTTlBIDBBMywgQ2FuYWRh':
            //3 Michael Power
            postalCode = 'M9A 0A2';
            break;
        case 'ChIJoSm_jxA2K4gRcCwypyaenDo':
            //15 Legion Road
            postalCode = 'M8V 0A9';
            break;
        case 'ChIJMxZvnFMyK4gRrddO2TTIiTY':
            //35 Saranac
            postalCode = 'M6A 2G4';
            break;
        case 'ChIJMXqi36o1K4gRNFHawCQ7cCk':
            //20 Minowan Miikan
            postalCode = 'M6J 0E5';
            break;
        case 'ChIJU2b60xg1K4gR5jiWNcR60yA':
            //231 Fort York
            postalCode = 'M5V 1B2';
            break;
        case 'Ei4xNjUgTGVnaW9uIFJkIE4sIEV0b2JpY29rZSwgT04gTThZIDBBNywgQ2FuYWRh':
            //165 Legion
            postalCode = 'M8Y 0B3';
            break;
        case 'ChIJ-x6E6xY2K4gRTZf3Afapud4':
            //155 Legion
            postalCode = 'M8Y 0A7';
            break;
        case 'ChIJLzIa6hY2K4gR5l4lhiSDblI':
            //185 Legion
            postalCode = 'M8Y 0A1';
            break;
        case 'ChIJjSKQuBY2K4gRVBo6MFEx-KM':
            //185 Legion
            postalCode = 'M8Y 0A1';
            break;
        case 'ChIJ3b5sKBA2K4gR8Qa8rjrxLhw':
            //2212 Lake Shore
            postalCode = 'M8V 0C2';
            break;
        case 'ChIJOcboSXM2K4gR_QDxi-BdvS0':
            //2230 Lake Shore
            postalCode = 'M8V 0B2';
            break;
        case 'ChIJF-Q2uqsFzkwRt20qazGZ_Fs':
            //179 Metcalfe
            postalCode = 'K2P 0W1';
            break;
        case 'ChIJyT23nxE2K4gR7ANb9Yno8Nw':
            //88 Park Lawn
            postalCode = 'M8Y 0B5';
            break;
        case 'ChIJR219nxE2K4gRGGg0ARAbvng':
            //88 Park Lawn
            postalCode = 'M8Y 0B5';
            break;
        case 'ChIJwYAVYNU0K4gRedlMkDtSwIE':
            //218 Queens Quay
            postalCode = 'M5J 2Y6';
            break;
        case 'ChIJDTFXeio1K4gRxrJyK_5Pa1I':
            //230 Queens Quay
            postalCode = 'M5J 2Y7';
            break;
        case 'ChIJayLdoq00K4gR4Ht5MCr9bAs':
            //50 Charles
            postalCode = 'M4Y 1T1';
            break;
        case 'ChIJTXyXlq00K4gRFQIZs4-fzLQ':
            //42 Charles
            postalCode = 'M4Y 1T4';
            break;
        case 'ChIJb6F7CEc0K4gRZXHHr9RwmXk':
            //1369 Bloor
            postalCode = 'M6P 4J4';
            break;
        case 'ChIJxTi8SnY2K4gRcXEjgVXx9nQ':
            //105 The Queensway
            postalCode = 'M6S 5B5';
            break;
        case 'ChIJSb1MSnM2K4gRDGk_Tpa_QsU':
            //2083 Lake Shore Blvd W
            postalCode = 'M8V 4G2';
            break;
        case 'ChIJUxR8qww2K4gRcdKzqO7rco4':
            //2095 Lake Shore Blvd W
            postalCode = 'M8V 4G4';
            break;
        case 'ChIJv0aV37Q0K4gRSSUwyDy6kYM':
            //25 Carlton
            postalCode = 'M5B 1L3';
            break;
        case 'ChIJ7-A64bQ0K4gR3DYQcevr_Xo':
            //21 Carlton
            postalCode = 'M5B 1L4';
            break;
        case 'ChIJBUTbV3M2K4gRrcW8p986TLo':
            //5 Marine Parade
            postalCode = 'M8V 4B4';
            break;
        case 'ChIJLcbj87MzK4gR-iBgG_u5AHw':
            //650 Lawrence Ave W
            postalCode = 'M6A 3E8';
            break;
        case 'ChIJSb8UmiE1K4gRE81W_oVNxVY':
            //15 Bruyeres Mews
            postalCode = 'M5V 0A7';
            break;
        case 'ChIJfb5ajloEzkwRKQJIvGrgyXQ':
            //200 Lett
            postalCode = 'K1R 0A7';
            break;
        case 'ChIJE7rDmloEzkwRrqOnWi0hQ_c':
            //250 Lett
            postalCode = 'K1R 0A8';
            break;
        case 'ChIJ_-nfJdo0K4gRkUjB98-tzpI':
            //8 Charlotte
            postalCode = 'M5V 0K4';
            break;
        case 'ChIJs6FxfuA0K4gRJNsqLla_I7g':
            //700 King
            postalCode = 'M5V 2Y6';
            break;
        case 'ChIJVygmYzIEzkwRHFHgwO02MUI':
            //327 Breezehill
            postalCode = 'K1Y 1R6';
            break;
        case 'ChIJ5e2vSxA2K4gRhAPFPgmtpXQ':
            //2220 Lake Shore Blvd. W
            postalCode = 'M8V 0C1';
            break;
        case 'ChIJi0RnLhA2K4gR-oBdbioyRJU':
            //2200 Lake Shore Blvd. W
            postalCode = 'M8V 1A4';
            break;
        case 'ChIJxWF5BdU0K4gRQYx563MEzmY':
            //19 Grand Trunk (DOES NOT HAVE SERVICE)
            postalCode = 'M5J 3A5';
            break;
        case 'ChIJEYY3xLEFzkwRanBcm0SKkhk':
            //360 McLeod
            postalCode = 'K2P 1A9';
            break;
        case 'ChIJ-6XmGd40K4gR-waRTdBsGZA':
            //525 Adelaide St W
            postalCode = 'M5V 1T6';
            break;
        default:
            const component = place.address_components ? place.address_components.find((component) => {
                return component.types.indexOf('postal_code') !== -1;
            }) : {};
            return (component && component.short_name) || null;

    }
    return postalCode;
}

export function isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function getFormattedErrors(errors) {
    const formattedErrors = {
        message: errors.message,
        fields: {},
        code: errors.status_code
    }

    for (let prop in errors.errors) {
        formattedErrors.fields[prop] = errors.errors[prop][0];
    }

    return formattedErrors;
}

export function emailMask(ref) {
    const eMask = new Inputmask({ alias: "email" });
    eMask.mask(ref);
}

export function phoneMask(ref) {
    const pMask = new Inputmask("999 999 9999", {
        showMaskOnHover: false,
        placeholder: "",
        autoUnmask: true,
    });
    pMask.mask(ref);
}

export function largeScreenMatchMedia() {
    return window.matchMedia('(min-width: 1920px)').matches;
}
export function mobileMatchMedia() {
    return window.matchMedia('(max-width: 767px)').matches;
}

export function ipadMatchMedia() {
    return window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches;
}
export function tabletMatchMedia() {
    return window.matchMedia('(min-width: 768px) and (max-width: 991px)').matches;
}

export function setTitle(title) {
    return title ? title : document.title;
}

export function setMetaDescription(description) {
    description = document.querySelector('meta[name=description]').setAttribute('content', description);
    return description;
}

export function googleTracking(event) {
    window.dataLayer.push(event);
}

export function addBusinessDays(momentDate, days) {
    const increment = days / Math.abs(days);
    const date = momentDate.clone().add(Math.floor(Math.abs(days) / 5) * 7 * increment, 'days');
    let remaining = days % 5;
    while (remaining !== 0) {
        date.add(increment, 'days');
        if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7)
            remaining -= increment;
    }
    return date;
}

export function getUrlParameters() {
    const url = window.location.href;
    const params = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
}

export function joinQueryString(params) {
    const queryString = Object.keys(params).map(function (key) {
        return key + '=' + params[key]
    }).join('&');
    return queryString;
}

export function shouldProcessAsUnscheduledLead(service) {
    return (service === "FIBRE5000");
}



// WEBPACK FOOTER //
// ./src/util.js